module.exports = __webpack_public_path__ + "static/logo-1825c5be2b4203948744d115dd2d1439.svg";